import type { RefObject } from 'react';
import type { IChatCommandWebMessage, IChatProvider } from '@enuan/chat__utils';

export const HISTORY_PAGE_SIZE = 20;
export const NORMAL_CLOSE_CODE = 1000;

export type ProviderOnOpen = Parameters<IChatProvider['onOpen']>[0];
export type ProviderOnChatMessage = Parameters<
	IChatProvider['onChatMessage']
>[0];
export type ProviderOnChatEcho = Parameters<IChatProvider['onChatEcho']>[0];
export type ProviderOnChatError = Parameters<IChatProvider['onChatError']>[0];
export type ProviderOnClose = Parameters<IChatProvider['onClose']>[0];
export type ProviderOnError = Parameters<IChatProvider['onError']>[0];

export type ConnectionInitEffectParams = {
	timestampRef: RefObject<string | undefined>;
	startConnection: () => unknown;
};

/**
 * Configuration and callbacks for chat initialization.
 *
 * @property params - Optional object sent to the API on channel open (and on USER_INFO when it changes).
 * @property onConnection - Called when the WebSocket connection is opened (receives the open event).
 * @property onWebMessage - Called when a web/command message is received from the provider.
 */
export type IUseChatProps = {
	params?: object;
	onConnection?: Parameters<IChatProvider['onOpen']>[0];
	onWebMessage?: (message: IChatCommandWebMessage) => void;
};
